export default (props) => {
  if (props.item.rootPosition) {
    return {
      ...props,
      lazy: props.item.rootPosition > props.lazyLoadingPosition,
      imageProps: {
        lazy: props.item.rootPosition > props.lazyLoadingPosition
      }
    }
  }
}
